import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DeviceModelListComponent } from './device-model-list.component';

const routes: Routes = [
  {
    path: 'device-model-list',
    data: { name: 'Device Model', isTab: false },
    component: DeviceModelListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceModelListRoutingModule {}
